export default __webpack_public_path__ + "status-new-md.4cdb09d4.svg";